
import { SlotMachineDigit } from './slot-machine-digit';

interface Props {
    value: number;
    duration?: number;
    prefix?: string;
    suffix?: string;
}

export const SlotCounter = ({ value, duration = 1.2, prefix = '', suffix = '' }: Props) => {
    const digits = value.toString().split('').map(Number);

    return (
        <div className="flex items-center">
            {prefix && <span className="mr-1">{prefix}</span>}
            {digits.map((d, i) => (
                <SlotMachineDigit key={i} digit={isNaN(d) ? 0 : d} duration={duration + (i * 0.1)} />
            ))}
            {suffix && <span className="ml-1">{suffix}</span>}
        </div>
    );
};
